module.exports = __webpack_public_path__ + "img/poster_3.0ea65955.png";